import React, { memo } from 'react';
import { IconProps } from '.';

type CancelFilledIconProps = {} & IconProps;

export const CancelFilledIcon: React.FC<CancelFilledIconProps> = memo(
  ({ width = 20, height = 20 }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle cx="12" cy="12" r="12" fill="#787878"></circle>
        <path stroke="#fff" d="M6.639 6.504L18.068 17.932"></path>
        <path stroke="#fff" d="M5.932 17.932L17.361 6.504"></path>
      </svg>
    );
  }
);
